(function () {
  function initReveal(root) {
    var items = root.querySelectorAll('[data-journal-reveal]');
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    items.forEach(function (el) { el.classList.add('reveal-ready'); });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { obs.observe(el); });
  }

  function initFilters(root) {
    var chips = root.querySelectorAll('[data-journal-chip]');
    var cards = root.querySelectorAll('[data-journal-card]');
    var empty = root.querySelector('[data-journal-empty]');
    if (!chips.length || !cards.length) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.toggle('active', c === chip);
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        var cat = (chip.getAttribute('data-cat') || 'all').toLowerCase();
        var visible = 0;
        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-cat') || '').toLowerCase();
          var show = cat === 'all' || tags.split('|').indexOf(cat) !== -1;
          card.classList.toggle('is-hidden', !show);
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  }

  function initSort(root) {
    var select = root.querySelector('[data-journal-sort]');
    var grid = root.querySelector('[data-journal-grid]');
    if (!select || !grid) return;
    select.addEventListener('change', function () {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-journal-card]'));
      var mode = select.value;
      cards.sort(function (a, b) {
        if (mode === 'popular') {
          return (parseInt(b.getAttribute('data-popular') || '0', 10) || 0) -
            (parseInt(a.getAttribute('data-popular') || '0', 10) || 0);
        }
        return (parseInt(b.getAttribute('data-date') || '0', 10) || 0) -
          (parseInt(a.getAttribute('data-date') || '0', 10) || 0);
      });
      cards.forEach(function (card) { grid.appendChild(card); });
    });
  }

  function boot(root) {
    if (!root || root.getAttribute('data-journal-ready')) return;
    root.setAttribute('data-journal-ready', '1');
    initReveal(root);
    initFilters(root);
    initSort(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-oxiram-journal]').forEach(boot);
    initArticlePage();
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-oxiram-journal]');
    if (root) boot(root);
    if (e.target && e.target.querySelector('[data-oxiram-article]')) initArticlePage();
  });

  function initArticlePage() {
    var root = document.querySelector('[data-oxiram-article]');
    if (!root || root.getAttribute('data-article-ready')) return;
    root.setAttribute('data-article-ready', '1');

    var bar = root.querySelector('[data-article-progress]');
    if (bar) {
      var onScroll = function () {
        var el = document.documentElement;
        var max = el.scrollHeight - el.clientHeight;
        var pct = max > 0 ? Math.min(100, Math.max(0, (el.scrollTop / max) * 100)) : 0;
        bar.style.width = pct + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var copyBtn = root.querySelector('[data-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-url') || window.location.href;
        var label = copyBtn.querySelector('[data-copy-label]');
        var done = function () {
          if (!label) return;
          var prev = label.textContent;
          label.textContent = 'Copied';
          setTimeout(function () { label.textContent = prev; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {
            window.prompt('Copy link', url);
          });
        } else {
          window.prompt('Copy link', url);
        }
      });
    }
  }
})();
